export const IMAGE_ZOOM = 0.95;
export const IMAGE_PADDING = (1 - IMAGE_ZOOM) / 2;
export const A4_WIDTH = 297 * 10;
export const A4_HEIGHT = 210 * 10;
